<template>

  <Component :is="comp" v-if="comp"/>

  <!-- Think Publications-->
  <!--  <template v-if="componentName == 'publications'">
      &lt;!&ndash; publications &ndash;&gt;
      <PublicationsComponent />
    </template>

    &lt;!&ndash; Think Innovation &ndash;&gt;
    <template v-if="componentName == 'thinkinnovation'">
      &lt;!&ndash; thinkinnovation &ndash;&gt;
      <ThinkInnovations />
    </template>

    &lt;!&ndash; Do &ndash;&gt;
    <template v-if="componentName == 'projects'">
      &lt;!&ndash; projects &ndash;&gt;
      <ProjectsComponent />
    </template>

    &lt;!&ndash; Think Innovation &ndash;&gt;
    <template v-if="componentName == 'offCanvasSearch'">
      &lt;!&ndash; thinkinnovation &ndash;&gt;
      <offCanvasAppComponent />
    </template>


    &lt;!&ndash; Support &ndash;&gt;
    <template v-if="componentName == 'programRelatedInvestments'">
      &lt;!&ndash; programRelatedInvestments &ndash;&gt;
      <supportProgramRelatedInvestments />
    </template>

    &lt;!&ndash; Support &ndash;&gt;
    <template v-if="componentName == 'grantMaking'">
    &lt;!&ndash; grantMaking &ndash;&gt;
      <supportGrantMaking />
    </template>

    &lt;!&ndash; Support &ndash;&gt;
    <template v-if="componentName == 'communityFund'">
    &lt;!&ndash; communityFund &ndash;&gt;
      <supportCommunityFund />
    </template>


    &lt;!&ndash; Support &ndash;&gt;
    <template v-if="componentName == 'participatoryfunds'">
    &lt;!&ndash; communityFund &ndash;&gt;
      <supportCommunityFund />
    </template>

    &lt;!&ndash; Support &ndash;&gt;
    <template v-if="componentName == 'policyMeetsPractice'">
    &lt;!&ndash; policyMeetsPractice &ndash;&gt;
      <supportPolicyMeetsPractice />
    </template>-->

</template>


<script setup>

import offCanvasAppComponent from '@/components/offCanvasAppComponent.vue'
import PublicationsComponent from '@/components/PublicationsComponent.vue'
import ProjectsComponent from '@/components/ProjectsComponent.vue'
import ThinkInnovations from "./components/thinkInnovations.vue";

import supportProgramRelatedInvestments from '@/components/supportProgramRelatedInvestments.vue'
import supportGrantMaking from '@/components/supportGrantMaking.vue'
import supportCommunityFund from '@/components/supportCommunityFund.vue'
import supportPolicyMeetsPractice from '@/components/supportPolicyMeetsPractice.vue'


let comp = null;


/*let componentName = ref('');


let offCanvasSearch = '/search/'
let thinkPublications = '/think/publications/'
let thinkSupport = '/think/'
let thinkInnovation = '/think/innovation/'

let doProjects = '/do/projects/'
let doHome = '/do/'

let supportHome = '/support/'
let grantmaking = '/support/grant-making/'

let programrelated = '/support/program-related-funding/'
let policy = '/support/policy-meets-practice/'

let communityfund = '/support/participatory-funds/community-fund-for-wellness/'
let communityfundnew = '/support/participatory-funds/community-fund-for-wellness/'
let participatoryfunds = '/support/participatory-funds/'*/



let url = new URL(window.location.href);
let urlPath = url.pathname;

const paths = {
  '/think/' : {
    'default' : PublicationsComponent,
    '/innovation/' : ThinkInnovations,
  },
  '/do/' : {
    'default' : ProjectsComponent,
  },
  '/support/' : {
    'default' : supportGrantMaking,
    '/grant-making/' : supportGrantMaking,
    '/program-related-funding/' : supportProgramRelatedInvestments,
    '/policy-meets-practice/' : supportPolicyMeetsPractice,
    '/participatory-funds/' : supportCommunityFund
  },
  '/search/' : {
    'default' : offCanvasAppComponent,
  }
};

let getComponent = () => {
  let comp = null;
  for (let pPath in paths) {
    if (urlPath.includes(pPath)) {
      let subPaths = paths[pPath];
      comp = subPaths['default'];
      for (let subPath in subPaths) {
        if (subPath !== 'default' && urlPath.includes(subPath)) {
          console.log('-- comp path=' + subPath)
          return subPaths[subPath];
        }
      }
      console.log('-- comp path=' + pPath);
      return comp;
    }
  }
}

comp = getComponent();

/*switch (urlPath) {
  case '/think/publications/':
  case '/think/':
    comp = PublicationsComponent;
    break;

  case '/search/':
    comp = offCanvasAppComponent;
    break;

  case '/think/innovation/':
    comp = ThinkInnovations;
    break;

  case '/do/projects/':
  case '/do/':
    comp = ProjectsComponent;
    break;

  case '/support/grant-making/':
  case '/support/':
    comp = supportGrantMaking;
    break;

  case '/support/program-related-funding/':
    comp = supportProgramRelatedInvestments;
    break;

  case '/support/policy-meets-practice/':
  case '/support/special-grant-programs/policy-meets-practice/':
    comp = supportPolicyMeetsPractice;
    break;

  case '/support/participatory-funds/overdose-prevention-and-community-healing-fund/':
  case '/support/participatory-funds/community-fund-for-wellness/':
  case '/support/participatory-funds/kcrf/':
  case '/support/participatory-funds/kcrf-es/':
  case '/support/participatory-funds/':
    comp = supportCommunityFund;
    break;

}*/


// console.log( url );

/*if( urlPath == thinkPublications || urlPath == thinkSupport ){

  console.log('showPubications')
  componentName.value = 'publications'

}

if( urlPath == thinkInnovation ){

  console.log('showThinkInnovation')
  componentName.value = 'thinkinnovation'

}

if( urlPath == offCanvasSearch ){

  console.log('showoffCanvas')
  componentName.value = 'offCanvas'

}


if( urlPath == doProjects || urlPath == doHome ){

  console.log('show Projects')
  componentName.value = 'projects'

}

if( urlPath == grantmaking || urlPath == supportHome ){

  console.log('show Projects')
  componentName.value = 'grantMaking'

}

if( urlPath == grantmaking || urlPath == supportHome ){

  console.log('show Projects')
  componentName.value = 'grantMaking'

}

if( urlPath == programrelated ){

  console.log('show Projects')
  componentName.value = 'programRelatedInvestments'

}

if( urlPath == policy ){

  console.log('show Projects')
  componentName.value = 'policyMeetsPractice'

}

if( urlPath == communityfund || urlPath == participatoryfunds || urlPath == communityfundnew ){

  console.log('show Projects')
  componentName.value = 'communityFund'

}*/

// console.log( 'urlCheck=' + urlPath.indexOf( publicationsURL ) )
//console.log( 'componentName=' + componentName.value )


</script>

<style>

@import url("https://fonts.googleapis.com/css?family=Roboto+Slab|Roboto:300,300i,400,400i,500,700");
/* @import url("https://www.scattergoodfoundation.org/wp-content/themes/scattergood/css/child-theme.min.css?ver=0.3.11"); */
/* @import url("https://sg.jb.local/wp-content/themes/scattergood/css/child-theme.min.css?ver=0.3.11"); */
#app {

  text-align: left;

}

#app #publications-search input.form-control {
  height: 60px !important;
  border-top: 1px solid #d2d2d2;
}

#app .box-publications {
  margin-top: 25px !important;
  width: unset !important;
}

.projects-helper__right {
  margin-top: 0;
}

.navbar-filter {
  margin-top: 3px;
}

.filter-view {
  margin-top: 18px;
}

/* .vue-label{
  text-align:left;font-size:14px;font-weight: normal;margin:auto;
  padding-top: 8px;
  padding-top: 8px;
} */
.projects-helper > div:last-child,
.projects-helper > div:first-child {
  /* width: unset !important; */
}

.projects-helper__right {
  float: right;
  width: 50% !important;
}

.projects-helper__left {
  float: left;
  width: 50% !important;
}

.author-info {
  padding-left: 0px;
}

.vue-label {
  display: inline-block;
  padding-left: 18px;
  position: relative;
  font-size: 14px;
}

.vue-label input {
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 4px;
  /* float:left;margin:auto;margin-right:5px;margin-top: 3px; */
}

#app .dropdown-toggle-vue {

  text-align: center !important;

}

.dropdown-toggle-vue::after {
  /* content: unset !important; */

}

/* .form-search .form-control{
  max-width: 75%;
} */
#publications-search input.form-control {
  /* width: 100%; */
}


.pre-results .slider-think__item:nth-child(n+13), .searchwp-live-search-results .slider-think__item:nth-child(n+13),
.pre-results .slider-think__item:nth-child(n+13),
.pre-results .slider-think__item:nth-child(n+13), .searchwp-live-search-results .slider-think__item:nth-child(n+13),
.pre-results .slider-think__item:nth-child(n+13) {
  display: block;
}

.page-template-page-think .slider-think__item, .single-projects #publication .slider-think__item {
  /* margin-bottom: 0; */
}

@media (max-width: 768px) {
  .matchme {
    height: 510px;
  }
}

@media (min-width: 769px) {
  .matchme {
    height: auto !important;
  }
}

.vue-bgimage {

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

/* #app .btn-group.thinkDropdown{
  width: 33.3333% !important;
} */
@media ( min-width: 769px ) {
  #app .thinkDropdown .caret-vue {
    /* right: 46px; */
  }
}

@media (max-width: 769px) {


  #app #grantees-tab .thinkDropdown {
    width: 125px !important;
  }

  #app #grantees-tab .supportDropdown {
    width: 125px !important;
  }

  .page-template-page-support-award #app #grantees-tab .btn-group.thinkDropdown {
    /* width: 33.3333% !important; */
  }

  .page-template-page-support-award .projects-helper > div:last-child {
    width: 100% !important;
  }

}
</style>